import React, { Dispatch, SetStateAction } from 'react';

export type TOptions = {
  items: TOptionItem[];
};

export type TOptionItem = {
  id: number;
  name: string;
  price: number;
  priceExtra: number;
  isPricePerMeter: boolean;
  isPercentToFullPrice: boolean;
  isPriceFromMaterial?: boolean;
  pricePropertyCode?: string;
  minPrice?: number;
  isSet: boolean;
  isHidden: boolean;
  isExtraPrice: boolean;
  isIndividualPrice: boolean;
  dataText: string;
};

type CanvasOptionsContextType = {
  options: TOptions | null;
  setOptions: Dispatch<SetStateAction<TOptions | null>>;
};

export const canvasOptionsContext = React.createContext<CanvasOptionsContextType>({
  options: {
    items: [
      {
        id: 0,
        name: '',
        price: 0,
        priceExtra: 0,
        isPricePerMeter: false,
        isPercentToFullPrice: false,
        isPriceFromMaterial: false,
        pricePropertyCode: '',
        minPrice: 0,
        isSet: false,
        isHidden: false,
        isExtraPrice: false,
        isIndividualPrice: false,
        dataText: '',
      },
    ],
  },

  setOptions: () => {},
});
